@use "styles/abstracts/variables" as v;

.list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.loaderModal {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 128px;
}
